package org.ksdfv.thelema.kxjs.data

import org.khronos.webgl.ArrayBufferView
import org.khronos.webgl.Int32Array
import org.khronos.webgl.get
import org.khronos.webgl.set
import org.ksdfv.thelema.data.IIntData

class JsInt32Array(val intArray: Int32Array): IIntData, JsArrayBufferView<Int>() {
    override val array: ArrayBufferView
        get() = intArray

    override var size: Int = intArray.length

    override val capacity: Int
        get() = intArray.length

    override fun set(index: Int, value: Int) {
        intArray[index] = value
    }

    override fun get(index: Int): Int = intArray[index]

    override fun get(): Int {
        val value = intArray[position]
        position++
        return value
    }

    override fun put(value: Int) {
        intArray[position] = value
        position++
    }
}